import React, { FC } from 'react';
import { ImageMedia } from '~/lib';
import { Image } from '~/shared/components/Image/Image';
import styles from '../../PLPHero.module.scss';

export interface PLPHeroImageProps {
    image: ImageMedia;
    imageAltText?: string;
    children?: React.ReactNode; // For breadcrumb overlay
}

/**
 * PLPHeroImage component handles the hero image display with proper optimization
 * for above-the-fold content and responsive sizing.
 */
export const PLPHeroImage: FC<PLPHeroImageProps> = ({ image, imageAltText, children }) => {
    return (
        <div className={styles.imageContainer}>
            <Image
                src={image.src}
                alt={image.alt || imageAltText}
                className={styles.heroImage}
                layout="responsive"
                width={1920}
                height={1080}
                priority
                objectFit="cover"
                quality={90}
                sizes="(max-width: 768px) 100vw, (max-width: 1024px) 367px, (max-width: 1440px) 613px, 800px"
            />
            {children}
        </div>
    );
};

export default PLPHeroImage;
